/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type EmailEventType = typeof EmailEventType[keyof typeof EmailEventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmailEventType = {
  WELCOME_MESSAGE: 'WELCOME_MESSAGE',
  RATE_CHANGE_APPROVED: 'RATE_CHANGE_APPROVED',
  PRODUCT_PUBLISHED: 'PRODUCT_PUBLISHED',
  PRODUCT_APPROVED: 'PRODUCT_APPROVED',
  NEW_USER_INVITE: 'NEW_USER_INVITE',
  BANKS_DAILY_INSTRUCTIONS: 'BANKS_DAILY_INSTRUCTIONS',
  PLATFORMS_DAILY_INTEREST: 'PLATFORMS_DAILY_INTEREST',
  PLATFORMS_DAILY_DISTRIBUTIONS: 'PLATFORMS_DAILY_DISTRIBUTIONS',
  PLATFORMS_DAILY_ORDER_ANALYTICS: 'PLATFORMS_DAILY_ORDER_ANALYTICS',
  OPS_NEW_PRODUCT_REQUEST: 'OPS_NEW_PRODUCT_REQUEST',
  OPS_RATE_CHANGE_REQUEST: 'OPS_RATE_CHANGE_REQUEST',
  OPS_PRODUCT_CLOSURE_REQUEST: 'OPS_PRODUCT_CLOSURE_REQUEST',
  RESET_PASSWORD: 'RESET_PASSWORD',
  ORDER_FILE_RECEIVED: 'ORDER_FILE_RECEIVED',
  PLATFORMS_MONTHLY_DISTRIBUTIONS: 'PLATFORMS_MONTHLY_DISTRIBUTIONS',
  COMPLIANCE_INTERVENTION_REQUIRED: 'COMPLIANCE_INTERVENTION_REQUIRED',
  TRANSACTION_MONITORING_ALERT: 'TRANSACTION_MONITORING_ALERT',
  COMPLIANCE_DOCUMENT_UPLOADED: 'COMPLIANCE_DOCUMENT_UPLOADED',
} as const;
